<!-- 示例页面 -->
<template>
  <div class="page">
    <div class="p16">
      修护审核
    </div>
    <div class="page-head">
      <div class="mains-content br10">
        <div class="member-content-box ">
          <div class="member-header">
            <div class="flex-row space-between">
              <div class="flex-row mr10">
                <el-select v-model="query.auditStatus" class="select" placeholder="审核状态" filterable>
                  <el-option label="全部状态" value></el-option>
                  <el-option label="待审核" value="wait"></el-option>
                  <el-option label="审核通过" value="pass"></el-option>
                  <el-option label="审核不通过" value="refuse"></el-option>
                </el-select>
              </div>
              <v-notDate @time="changeDate" class="mr10"></v-notDate>
            </div>
            <el-button type="primary" @click="doData">搜索</el-button>
          </div>
          <div class="plr16" v-perm="{ key: 'repairAudit', value: 'repairAudit:list' }">
            <el-table :data="list" :max-height="height - 266" header-cell-class-name="table_header_bgcolor">
              <el-table-column :prop="index" :align="item.align" :label="item.label" :width="item.width"
                :min-width="item.minWidth" :formatter="item.formatter" show-overflow-tooltip
                v-for="(item, index) in columns" :key="index" class="tr">
                <template slot-scope="scope">
                  <div v-if="index == 'auditStatus'">
                    <span :class="scope.row.auditStatus == 'wait' ? 'blue' : (scope.row.auditStatus == 'refuse' ? 'red' : '')">{{
                      scope.row.auditStatusCn }}</span>
                  </div>
                  <div v-else-if="index == 'symptom'">
                    <span>{{ scope.row.categoryId == 'f' ? '不限' : scope.row.symptom }}</span>
                  </div>
                  <div v-else>{{ Boolean(item.formatDate) ? formatDate(scope.row[index]) : scope.row[index] }}</div>
                </template>
              </el-table-column>
              <el-table-column prop="amt" label="操作" align="center" fixed="right" width="100">
                <template slot-scope="scope">
                  <div v-if="!scope.row.tatalsShow">
                    <el-link type="primary" @click="orderDetailPage(scope.row)">详情</el-link>
                  </div>
                </template>
              </el-table-column>
            </el-table>
            <paging :currentPage="query.start" :totalCount="totalCount" @doPageQuery="doDataQuery"></paging>
          </div>
        </div>
      </div>
    </div>
    <detail-set ref="detailSetForm" @change="handleChange"></detail-set>
  </div>
</template>

<script>
import minxin from "../../../assets/javascript/minxin.js";
import config from "./config/columns";
import detailSet from "./detail";
export default {
  data() {
    return {
      url: this.$url.repairRecord.listForAudit,
      query: {
        auditStatus: "",
        start: 0,
        size: 20,
        beginTime: '',
        endTime: ''
      },
      height: this.$store.getters.MainHeight,
      columns: config.columns,
      list: []
    };
  },
  mixins: [minxin],
  components: { detailSet },
  computed: {},

  created() {
    this.query.beginTime = this.formatDay(new Date());
    this.query.endTime = this.query.beginTime;
    this.totalCounts();
  },

  methods: {
    back() {
      this.$router.push("/collectMoney");
    },
    orderDetailPage(row) {
      this.$refs["detailSetForm"].$emit("set", row);
      // this.$router.push(`/repair/detail/${row.id}`);
    },
    selectChange() {
      this.totalCounts();
    },
    changeDate(value) {
      this.query.beginTime = value[0] ? this.formatDay(value[0]) : '';
      this.query.endTime = value[1] ? this.formatDay(value[1]) : '';

    },
    handleChange(bool) {
      if (bool) {
        this.totalCounts();
      }
    },
    totalCounts() {
      this.$api.post(this.$url.repairRecord.count, this.query).then(res => {
        this.getData();
        this.totalCount = res;
      }).catch(error => { });
    },
  }
};
</script>
<style scoped lang="less">
@import "../../../assets/css/edit.less";

.page-head {
  height: 100%;
}

.mains-content {
  background: #fff;
  height: calc(100% - 72px);

  .member-header {

    padding: 16px;
    display: flex;
    align-items: center;

    .top-label {
      width: 90px;
    }
  }
}
</style>

